import { HttpClient } from "@angular/common/http";
import { LacrosseEntity } from "../lacrosse.entity";
import { FirebaseAuthService } from "../../noizu/services/firebase-auth.service";
import { GatewayCycleOverrideEntity } from "./cycle-override.entity";
import { GatewayScriptOverrideEntity } from "./script-override.entity";

export class GatewayFirmwareReportEntity extends LacrosseEntity {
  public _kind = "firmware-report";
  public _singular = "firmware-report";

  public gateway: any = null;
  public gateway_entity: any = null;
  public last_reported: any = null;
  public assigned: any = null;
  public pending: any = null;
  public firmware_links: any = null;
  public cycle_override: GatewayCycleOverrideEntity = null;
  public script_override: GatewayScriptOverrideEntity = null;
  public report: any = null;
  public history: any = null;
  public worker_state: any = null;
  public roll_out: any = null;

  constructor(client: HttpClient, auth: FirebaseAuthService, json) {
    super(client, auth, json);
    this.refresh_content(json);
  }

  refresh_mcu_content(entity, json) {
    entity.gateway = json["gateway"];
    entity.gateway_entity = json["gateway_entity"];
    entity.last_reported = json.last_reported;
    entity.assigned = json.assigned;
    entity.pending = json.pending;
    entity.firmware_links = json["links"];
    if (json["cycle_override"]) {
      entity.cycle_override = new GatewayCycleOverrideEntity(
        json["cycle_override"]
      );
    } else {
      entity.cycle_override = null;
    }

    if (
      json["script_override"] &&
      (json["script_override"]["has_overide"] ||
        json["script_override"]["has_override"])
    ) {
      entity.script_override = new GatewayScriptOverrideEntity(
        json["script_override"]
      );
    } else {
      entity.script_override = null;
    }
    entity.report = json.report;
    entity.history = json.history;
    entity.worker_state = json["worker_firmware_details"];
    entity.roll_out = json["roll_out"];
  }

  refresh_content(json) {
    this.gateway = json["gateway"];
    this.gateway_entity = json["gateway_entity"];

    try {
      if (!this.gateway_entity["series"] && this.gateway_entity["identifier"]) {
        if (
          this.gateway_entity["identifier"]["tuple"] &&
          this.gateway_entity["identifier"]["tuple"][0]
        ) {
          this.gateway_entity["series"] =
            this.gateway_entity["identifier"]["tuple"][0];
          if (this.gateway_entity["series"])
            this.gateway_entity["series"] =
              this.gateway_entity["series"].toUpperCase();
        }
      }
      if (!this.gateway_entity["serial"] && this.gateway_entity["identifier"]) {
        if (
          this.gateway_entity["identifier"]["tuple"] &&
          this.gateway_entity["identifier"]["tuple"][1]
        ) {
          this.gateway_entity["serial"] =
            this.gateway_entity["identifier"]["tuple"][1];
          if (this.gateway_entity["serial"]) {
            let c = this.gateway_entity["serial"];
            this.gateway_entity["serial"] = c
              .toString(16)
              .padStart(6, "0")
              .toUpperCase();
          }
        }
      }
    } catch (e) {
      console.log("ISSUE REPAIRING SERIES,SERIAL", e);
    }

    this.last_reported = json.last_reported;
    this.assigned = json.assigned;
    this.pending = json.pending;
    this.firmware_links = json["links"];
    if (json["cycle_override"]) {
      this.cycle_override = new GatewayCycleOverrideEntity(
        json["cycle_override"]
      );
    } else {
      this.cycle_override = null;
    }

    if (
      json["script_override"] &&
      (json["script_override"]["has_overide"] ||
        json["script_override"]["has_override"])
    ) {
      this.script_override = new GatewayScriptOverrideEntity(
        json["script_override"]
      );
    } else {
      this.script_override = null;
    }
    this.report = json.report;
    this.history = json.history;
    this.worker_state = json["worker_firmware_details"];
    this.roll_out = json["roll_out"];
  }

  forceMcuRefresh() {
    const url = `${this.ingvEndpoint()}/admin-tools/gateway/${
      this.gateway
    }/mcu-info/force-check`;
    return this._put(url, {}, (json, resolve) => {
      this.refresh_content(json);
      resolve(this);
    });
  }

  forceRefresh() {
    const url = `${this.ingvEndpoint()}/admin-tools/gateway/${
      this.gateway
    }/firmware-info/force-check`;
    return this._put(url, {}, (json, resolve) => {
      this.refresh_content(json);
      resolve(this);
    });
  }

  refreshData(entity: any) {
    const url = `${this.ingvEndpoint()}/admin-tools/gateway/${
      this.gateway
    }/firmware-info`;
    return this._get(url, (json, resolve) => {
      this.refresh_content(json.wifi);
      this.refresh_mcu_content(entity, json.mcu);
      resolve(this);
    });
  }

  setCycle(update) {
    const url = `${this.ingvEndpoint()}/admin-tools/gateway/${
      this.gateway
    }/cycle`;
    return this._post(
      url,
      update,
      (data, resolve) => {
        this.cycle_override = update;
        resolve(data);
      },
      {}
    );
  }

  clearCycle() {
    const url = `${this.ingvEndpoint()}/admin-tools/gateway/${
      this.gateway
    }/cycle`;
    return this._delete(
      url,
      (data, resolve) => {
        this.cycle_override = null;
        resolve(data);
      },
      {}
    );
  }

  setScript(update) {
    const url = `${this.ingvEndpoint()}/admin-tools/gateway/${
      this.gateway
    }/ota-sequence`;
    return this._post(
      url,
      update,
      (data, resolve) => {
        this.script_override = update;
        resolve(data);
      },
      {}
    );
  }

  clearScript() {
    const url = `${this.ingvEndpoint()}/admin-tools/gateway/${
      this.gateway
    }/ota-sequence`;
    return this._delete(
      url,
      (data, resolve) => {
        this.script_override = null;
        resolve(data);
      },
      {}
    );
  }

  setBatch(batch) {
    const url = `${this.ingvEndpoint()}/admin-tools/gateway/${
      this.gateway
    }/batch/${batch.batch}`;
    return this._put(
      url,
      {},
      (data, resolve) => {
        const kill_worker = `${this.ingvEndpoint()}/admin-tools/worker/ref.gateway-worker.${
          this.gateway_entity.serial
        }@${this.gateway_entity.series}/kill`;
        this._get(kill_worker, () => {});
        resolve(data);
      },
      {}
    );
  }

  targetStage() {
    const url = `${this.ingvEndpoint()}/admin-tools/gateway/${
      this.gateway
    }/target-stage`;
    return this._put(
      url,
      { value: "2h" },
      (data, resolve) => {
        resolve(data);
      },
      {}
    );
  }

  targetProd() {
    const url = `${this.ingvEndpoint()}/admin-tools/gateway/${
      this.gateway
    }/target-stage`;
    return this._delete(
      url,
      (data, resolve) => {
        resolve(data);
      },
      {}
    );
  }
}
